import api from 'ApiConfig';

const branchService = {
  createBranch: async (branchData) => {
    return api.post('/superadmin/create-branch', branchData);
  },
  allBranches: async (userId) => {
    return api.post('/superadmin/all-branch');
  },
  createAdmin: async (adminData) => {
    console.log(adminData, 'adminData');
    return api.post('/superadmin/create-admin', adminData);
  },
  getAllAdmin: async (userId) => {
    return api.post('/superadmin/all-admins', userId);
  },
  getAllBlockedAdmin: async (userId) => {
    return api.post('/superadmin/blocked-admins', userId);
  },

  updateAdmin: async (payload) => {
    const {
      name: Name,
      email: Email,
      password: Password,
      _id: adminId,
    } = payload;
    const updatedPayload = {
      Name,
      Email,
      Password,
      adminId,
      contact: payload.contact,
    };
    return api.post('/superadmin/update-admin-details', updatedPayload);
  },
  updateBranch: async (payload) => {
    return api.post('/superadmin/update-branch-details', payload);
  },
  verifyStudent: async (studentId, approved) => {
    return api.post('/superadmin/verify-student', { studentId, approved });
  },
  approveUnpausePlacement: async (notificationId, approve, adminReason) => {
    return api.post('/superadmin/approve-unpause-placement-req', {
      notificationId,
      approve,
      adminReason,
    });
  },
  unpausePlacement: async (studentId, unpauseReason) => {
    return api.post('/superadmin/unpause-placement', {
      studentId,
      unpauseReason,
    });
  },
};

export default branchService;
